import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const WidgetContainer = styled.div`
  background-color: ${customPalette.accent.white};
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  margin-right: 24px;

  h3 {
    font-size: 16px;
    font-weight: 700;
    color: ${customPalette.grey.main};
    margin-bottom: 16px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border-bottom: 1px solid ${customPalette.accent.white};
  margin-bottom: 12px;
`;

export const Headline = styled.h2``;
export const SubHeadline = styled.h3`
  margin-bottom: 8px;
`;
export const DocumentItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  a {
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const DocumentLink = styled.div`
  display: flex;
  align-items: center;
  color: ${customPalette.accent.main};

  span {
    margin-left: 8px;
  }

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const ActionButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-start;
`;

export const IconWrapper = styled.div`
  svg {
    margin-right: 8px;
    width: 24px;
    height: 24px;
  }
`;

export const MenuButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  width: 100px;
  z-index: 10;
`;

export const MenuItem = styled.button`
  display: block;
  width: 100%;
  padding: 8px;
  text-align: left;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #f3f3f3;
  }

  &.delete {
    color: red;
  }
`;

export const DocumentName = styled.div`
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
